import api from './client';

type LicenseCreatePayload =
  | { key: string; maxActivations: number; expiresAt?: string; notes?: string }
  | { key: string; max_activations: number; expires_at?: string; notes?: string };

type LicenseUpdatePayload =
  | {
      maxActivations?: number;
      expiresAt?: string | null;
      notes?: string | null;
      isActive?: boolean;
    }
  | {
      max_activations?: number;
      expires_at?: string | null;
      notes?: string | null;
      is_active?: boolean;
    };

export const licenseAPI = {
  getAll: async () => {
    const response = await api.get('/api/admin/license-keys');
    return response.data;
  },

  create: async (data: LicenseCreatePayload) => {
    const response = await api.post('/api/admin/license-keys', data);
    return response.data;
  },

  update: async (id: number, data: LicenseUpdatePayload) => {
    const response = await api.put(`/api/admin/license-keys/${id}`, data);
    return response.data;
  },

  delete: async (id: number) => {
    const response = await api.delete(`/api/admin/license-keys/${id}`);
    return response.data;
  },

  batchCreate: async (data: {
    count: number;
    maxActivations?: number;
    expiresAt?: string;
    notes?: string;
    prefix?: string;
    template?: string;
  }) => {
    const response = await api.post('/api/admin/license-keys/batch', data);
    return response.data;
  },

  batchDeactivate: async (ids: number[]) => {
    const response = await api.post('/api/admin/license-keys/batch-deactivate', { ids });
    return response.data;
  },

  getUsage: async (id: number) => {
    const response = await api.get(`/api/admin/license-keys/${id}/usage`);
    return response.data;
  },
};
